import type { ReactNode } from 'react';

interface SectionProps {
  /** Заголовок секции (как в Telegram Settings — uppercase, серый). Может быть строкой или ReactNode. */
  header?: ReactNode;
  /** Подсказка снизу — мелкий серый текст. */
  footer?: string;
  children: ReactNode;
}

/**
 * Секция в стиле Telegram: заголовок сверху, скруглённый блок,
 * опциональный пояснительный текст снизу.
 */
export function Section({ header, footer, children }: SectionProps): JSX.Element {
  return (
    <div style={{ marginBottom: 'var(--space-xl)' }}>
      {header && (
        <div
          style={{
            padding: '0 var(--space-lg) var(--space-sm)',
            color: 'var(--tg-hint)',
            fontSize: 'var(--font-sm)',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
          }}
        >
          {header}
        </div>
      )}
      <div
        style={{
          background: 'var(--tg-section-bg)',
          borderRadius: 'var(--radius-lg)',
          margin: '0 var(--space-md)',
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
      {footer && (
        <div
          style={{
            padding: 'var(--space-sm) var(--space-lg) 0',
            color: 'var(--tg-hint)',
            fontSize: 'var(--font-sm)',
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
}
